/* BLOCKS */
export const ANCHOR = "anchor";
export const AUTHOR = "author";
export const SIMPLE_TEXT_COLUMNS = "simpleTextColumns";
export const IMAGE_TEXT = "imageText";
export const IMAGE_BACKGROUND_TEXT = "imageBackgroundText";
export const INTRO = "intro";
export const FEATURED = "featured";
export const FULL_WIDTH_MEDIA = "fullWidthMedia";
export const CONTENT_CAROUSEL = "contentCarousel";
export const TEXT = "text";
export const IMAGE_ROW = "imageRow";
export const TESTIMONIAL_CAROUSEL = "testimonialCarousel";
export const LINK_LIST = "linkList";
export const PRICING_GRID = "pricingGrid";
export const HTML_SNIPPET = "htmlSnippet";
export const RENEW_CONSENT = "renewConsent";
export const MEDIA_GRID = "mediaGrid";

/* PAGES */
export const PAGE = "page";
export const PAGE_LOC_ACT = "pageLocAct";
export const PAGE_LOCATION = "pageLocation";
export const PAGE_ACTIVITY = "pageActivity";
export const PAGE_BLOG_ARCHIVE = "pageBlogArchive";

/* MISC */
export const PAGE_SETTINGS = "pageSettings";
export const CHECKOUT_SETTINGS = "checkoutSettings";
export const BLOG_CATEGORY = "blogCategory";
export const BLOG_POST = "blogPost";
export const NAVIGATION_PRIMARY = "navigationPrimary";
export const PROMO = "promo";
export const SPECIAL_EVENT = "specialEvent";
export const OFFER = "offer";
export const FAQ = "faq";
export const ITEM_HTML_MODAL = "itemHtmlSnippetModal";
export const ITEM_HTML = "itemHtmlSnippet";
export const ROOM_SELECT_GALLERY = "checkoutRoomSelectGallery";
export const CUSTOM_ORDER_ADDITIONS = "checkoutCustomOrderAdditions";
export const NAVIGATION_ITEM_EXTERNAL_LINK = "navigationItemExternalLink"